export const emptyTableCellClassName =
  'px-3 py-8 text-center text-sm text-[var(--stryzh-color-text-secondary)]'
